import { ErrorResponse, httpClient } from '@/api/http-client'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

const cancelContract = async (deal_key: string): Promise<{ code: string }> => {
  const response = await httpClient('accounting-dealer').delete<{
    code: string
  }>(`/v3/contract/${deal_key}/cancel`)

  return response.data
}

export const useCancelContract = (
  options?: UseMutationOptions<{ code: string }, ErrorResponse, string>,
) => {
  return useMutation({
    mutationFn: cancelContract,
    ...options,
  })
}
